import { gql } from "lib/apolloClient";

export const backdateTimeTableMutation = gql`
  mutation backdateTimeTable($input: BackdateTimetableTemplateInput!) {
    platform {
      backdateTimetableTemplate(input: $input) {
        isSuccess
      }
    }
  }
`;

export const changeUnitPlanTemplateMutation = gql`
  mutation changeUnitPlanTemplate($input: ChangeUnitPlanTemplateInput!) {
    planner {
      changeUnitPlanTemplate(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;

export const updateSnpPermissionsMutation = gql`
  mutation($apiType: INTERNAL_TOOL_API_TYPE_ENUM!, $params: JSON!) {
    platform {
      internalToolsGenericMutation(
        input: { apiType: $apiType, params: $params }
      ) {
        isSuccess
        warning
        data
        __typename
      }
      __typename
    }
  }
`;

export const uploadBulkAttendanceMutation = gql`
  mutation UploadAttendance($input: IntegrationUploadAttendanceInput!) {
    integration {
      integrationUploadAttendance(input: $input) {
        allow
        message
        job {
          id
          curriculum
          status
          s3Url
        }
      }
    }
  }
`;

export const internalToolsGenericMutation = gql`
  mutation($apiType: INTERNAL_TOOL_API_TYPE_ENUM!, $params: JSON!) {
    platform {
      internalToolsGenericMutation(
        input: { apiType: $apiType, params: $params }
      ) {
        isSuccess
        warning
        data
        __typename
      }
      __typename
    }
  }
`;

export const unitPlanBulkUploadMutation = gql`
  mutation unitPlanBulkUpload($input: BulkUnitPlanUploadActionInput!) {
    planner {
      unitPlanBulkUploadAction(input: $input) {
        isSuccess
      }
    }
  }
`;

export const unitPlanPDFBulkUploadMutation = gql`
  mutation unitPlanPDFBulkUpload($input: UnitPlanPDFBulkUploadInput!) {
    planner {
      unitPlanPDFBulkUpload(input: $input) {
        isSuccess
      }
    }
  }
`;

export const unitPlanPDFAnnotationMutation = gql`
  mutation unitPlanPDFAnnotation($input: UnitPlanPDFAnnotationInput!) {
    planner {
      unitPlanPDFAnnotation(input: $input) {
        isSuccess
        response
      }
    }
  }
`;

export const bulkUploadUnitExcelMutation = gql`
  mutation entityUpload($input: UnitPlanXlsxValidationActionInput!) {
    planner {
      unitPlanXlsxValidationAction(input: $input) {
        uploadStatus
        successData {
          added
        }
        errorData
      }
    }
  }
`;

export const bulkUploadCalendarMutation = gql`
  mutation calendarEntityValidationAction(
    $input: SchoolCalendarSheetValidationActionInput!
  ) {
    platform {
      schoolCalendarSheetValidationAction(input: $input) {
        uploadStatus
        successData {
          added
          __typename
        }
        errorData
        __typename
      }
      __typename
    }
  }
`;

export const finalUnitExcelUploadMutation = gql`
  mutation xlsxUploadResponse($input: UnitPlanXlsxUploadActionInput!) {
    planner {
      unitPlanXlsxUploadAction(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;

export const finalBulkUploadCalendarMutation = gql`
  mutation calendarEntityUploadAction(
    $input: SchoolCalendarSheetValidationActionInput!
  ) {
    platform {
      schoolCalendarSheetUploadAction(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;

export const addToddleBuddyMutation = gql`
  mutation platformMutation($input: AddToddleBuddyInput!) {
    platform {
      addToddleBuddy(input: $input) {
        id
        isSuccess
        warning
      }
    }
  }
`;

export const removeToddleBuddyMutation = gql`
  mutation platformMutations($id: ID!) {
    platform {
      removeToddleBuddy(id: $id) {
        id
        isSuccess
        warning
      }
    }
  }
`;

export const encryptDataMutation = gql`
  mutation encryptDataRequest($input: EncryptDataInput!) {
    platform {
      encryptDataRequest(input: $input) {
        isSuccess
        processedText
        __typename
      }
      __typename
    }
  }
`;

export const decryptDataMutation = gql`
  mutation decryptDataRequest($input: EncryptDataInput!) {
    platform {
      decryptDataRequest(input: $input) {
        isSuccess
        processedText
        __typename
      }
      __typename
    }
  }
`;

export const createWorkrampFoundationMutation = gql`
  mutation createWorkrampFoundation($input: CreateWorkrampFoundationInput!) {
    platform {
      createWorkrampFoundation(input: $input) {
        foundation {
          id
          name
          curriculum
          trainings {
            id
            name
          }
          workrampFoundationId
          tags
        }
        isSuccess
        warning
      }
    }
  }
`;

export const updateWorkrampFoundationMutation = gql`
  mutation updateWorkrampFoundation($input: UpdateWorkrampFoundationInput!) {
    platform {
      updateWorkrampFoundation(input: $input) {
        foundation {
          id
          name
          curriculum
          trainings {
            id
            name
          }
          tags
        }
        isSuccess
        warning
      }
    }
  }
`;

export const deleteWorkrampFoundationMutation = gql`
  mutation deleteWorkrampFoundation($input: DeleteWorkrampFoundationInput!) {
    platform {
      deleteWorkrampFoundation(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;

export const createWorkrampTrainingMutation = gql`
  mutation createWorkrampTraining($input: CreateWorkrampTrainingInput!) {
    platform {
      createWorkrampTraining(input: $input) {
        training {
          id
          name
          workrampTrainingId
        }
        isSuccess
        warning
      }
    }
  }
`;

export const updateWorkrampTrainingMutation = gql`
  mutation updateWorkrampTraining($input: UpdateWorkrampTrainingInput!) {
    platform {
      updateWorkrampTraining(input: $input) {
        training {
          id
          name
        }
        isSuccess
        warning
      }
    }
  }
`;

export const deleteWorkrampTrainingMutation = gql`
  mutation deleteWorkrampTraining($input: DeleteWorkrampTrainingInput!) {
    platform {
      deleteWorkrampTraining(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;

export const updateWorkrampFoundationsOrderMutation = gql`
  mutation updateWorkrampFoundationsOrder(
    $input: [UpdateWorkrampFoundationsOrderInput!]!
  ) {
    platform {
      updateWorkrampFoundationsOrder(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;

export const bulkImportActivitiesMutation = gql`
  mutation bulkImportActivities($input: BulkImportActivitiesInput!) {
    planner {
      bulkImportActivities(input: $input) {
        isSuccess
        warning
        workflowId
      }
    }
  }
`;
